import { Component } from '@angular/core';

@Component({
  selector: 'landing-flow-diagram',
  templateUrl: './flow-diagram.component.html',
  styleUrls: ['./flow-diagram.component.scss'],
})
export class FlowDiagramComponent {}
